import { UserRole } from "../../../app/userSlice";
import { EditUserViewModel } from "../usersApiSlice";
import UserAccountSettingsSection from "./accountSettings/UserAccountSettingsSection";
import UserProfileSection from "./UserProfileSection";

interface UserInfoProps {
	userInfo: EditUserViewModel;
	setSuccessMessage: (message: string) => void;
	setErrorMessage: (message: string) => void;
}

export default function UserInformationSection(props: UserInfoProps) {
	return (
		<section
			className={`${props.userInfo.role === UserRole.Writer ? "w-3/4" : "w-[70%]"} rounded-xl border border-gray-200 self-start`}>
			<div className="border-b border-gray-900/5 bg-gray-200/60 px-5 py-4 rounded-t-xl ">
				<p className="text-xl font-medium text-gray-900">User Information</p>
			</div>
			<div
				className={`${props.userInfo.showWelcomeEmailResend ? "" : "xl:flex-row"} flex flex-col bg-gray-50 rounded-b-xl`}>
				<UserAccountSettingsSection
					userInfo={props.userInfo}
					setSuccessMessage={props.setSuccessMessage}
					setErrorMessage={props.setErrorMessage}
				/>
				<div
					className={`${props.userInfo.showWelcomeEmailResend ? "" : "xl:flex-row xl:border-t-0 xl:border-l-2 xl:self-stretch"} border-t-2`}></div>
				<UserProfileSection
					userInfo={props.userInfo}
					setSuccessMessage={props.setSuccessMessage}
					setErrorMessage={props.setErrorMessage}
				/>
			</div>
		</section>
	);
}
